import { CalendarClock, ClipboardList, CalendarDays, PlayCircle } from "lucide-react";

const ICONS = { deadlines: CalendarClock, plans: ClipboardList, sessions: CalendarDays, next: PlayCircle };

/** Clear list card (Flow 9 style): short date on the left, bold item on the right. */
export const InfoListCard = ({ kind = "deadlines", title, subtitle, rows = [], mobileType = false, time }) => {
  const Icon = ICONS[kind] || CalendarClock;
  const size = mobileType ? "text-[15px]" : "text-[13px]";
  return (
    <div className="w-[94%] sm:w-[88%] max-w-[23rem] self-start overflow-hidden rounded-2xl rounded-tl-sm bg-white shadow-sm" data-testid={`info-card-${kind}`}>
      <div className="flex items-center gap-2 bg-[#EAF8F0] px-3 py-2">
        <Icon className="h-4 w-4 text-[#189346]" />
        <div>
          <p className={`font-semibold text-[#122118] ${size}`}>{title}</p>
          {subtitle && <p className="text-[11px] text-[#4a5f53]">{subtitle}</p>}
        </div>
      </div>
      <ul className="divide-y divide-gray-100 px-3">
        {rows.map((row, index) => (
          <li key={`${row.left}-${index}`} className="flex items-baseline gap-3 py-2" data-testid={`info-row-${kind}`}>
            <span className={`min-w-[5.8rem] shrink-0 whitespace-nowrap text-[#829C8D] ${mobileType ? "text-[14px]" : "text-[12px]"}`}>{row.left}</span>
            <span className="min-w-0 flex-1">
              <span className={`block font-semibold text-[#122118] ${size}`}>{row.right}</span>
              {row.sub && <span className="block text-[11px] text-[#4a5f53]">{row.sub}</span>}
            </span>
          </li>
        ))}
      </ul>
      <div className="px-3 pb-1.5 text-right text-[10px] text-gray-500">{time}</div>
    </div>
  );
};
